import React from "react";
import khuvsgul from "../images/users/khuvsgul.png";
import tuv from "../images/users/tuv.png";
import selenge from "../images/users/selenge.png";
import bulgan from "../images/users/bulgan.png";
import lun from "../images/users/lun.png";
import dundgovi from "../images/users/dundgovi.png";
import dornod from "../images/users/dornod.png";
import govisumber from "../images/users/govisumber.png";
import nalaikh from "../images/users/nalaikh.png";
import baganuur from "../images/users/baganuur.png";
import khovd from "../images/users/khovd.png";
import goviAltai from "../images/users/govi-altai.png";
import baynkhongor from "../images/users/bayn-khongor.png";
import uvs from "../images/users/uvs.png";
import ovorkhangai from "../images/users/ovorkhangai.png";
import orkhon from "../images/users/orkhon.png";
import arkhangai from "../images/users/arkhangai.png";
import zavkhan from "../images/users/zavkhan.png";
import omnogovi from "../images/users/omnogovi.png";
import khentii from "../images/users/khentii.png";
import sukhbaatar from "../images/users/sukhbaatar.png";
import baynUlgii from "../images/users/bayn-ulgii.png";

import tImg4 from "../images/users/review-user-4.jpg";

const Salbaruud = [
  {
    id: "01",
    tImg: khuvsgul,
    Name: "Хөвсгөл",
    // Title: "Amazing services",
    // Des: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form,",
    // sub: "Founder & Co (HTJ)",
  },
  {
    id: "02",
    tImg: tuv,
    Name: "Төв",
  },
  {
    id: "03",
    tImg: selenge,
    Name: "Сэлэнгэ",
  },
  {
    id: "04",
    tImg: bulgan,
    Name: "Булган",
  },
  {
    id: "05",
    tImg: lun,
    Name: "Лүн",
  },
  {
    id: "06",
    tImg: dundgovi,
    Name: "Дундговь",
  },
  {
    id: "07",
    tImg: dornod,
    Name: "Дорнод",
  },
  {
    id: "08",
    tImg: govisumber,
    Name: "Говьсүмбэр",
  },
  {
    id: "09",
    tImg: nalaikh,
    Name: "Налайх",
  },
  {
    id: "10",
    tImg: baganuur,
    Name: "Багануур",
  },
  {
    id: "11",
    tImg: khovd,
    Name: "Ховд",
  },
  {
    id: "12",
    tImg: goviAltai,
    Name: "Говь-Алтай",
  },
  {
    id: "13",
    tImg: baynkhongor,
    Name: "Баянхонгор",
  },
  {
    id: "14",
    tImg: uvs,
    Name: "Увс",
  },
  {
    id: "15",
    tImg: ovorkhangai,
    Name: "Өвөрхангай",
  },
  {
    id: "16",
    tImg: orkhon,
    Name: "Орхон",
  },
  {
    id: "17",
    tImg: arkhangai,
    Name: "Архангай",
  },
  {
    id: "18",
    tImg: zavkhan,
    Name: "Завхан",
  },
  {
    id: "19",
    tImg: omnogovi,
    Name: "Өмнөговь",
  },
  {
    id: "20",
    tImg: khentii,
    Name: "Хэнтий",
  },
  {
    id: "21",
    tImg: sukhbaatar,
    Name: "Сүхбаатар",
  },
  {
    id: "22",
    tImg: baynUlgii,
    Name: "Баян-Өлгий",
  },
];

export default Salbaruud;
